<script setup>
import { ref, computed, onMounted } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { usePlanningStore } from '@/stores/planning.store'

import WarehouseNameLabel from '@/components/shared/WarehouseNameLabel.vue'

const props = defineProps({
  modelValue: {
    type: Number,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: null,
  },
  exclude: {
    type: Number,
    default: null,
  },
  kind: {
    type: Number,
    default: null,
  },
  allowAll: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const i18n = getI18n()
const planningStore = usePlanningStore()
const { warehouseKindEnum } = planningStore
const warehouses = ref([])

const matchesKind = (warehouse) => {
  if (props.kind === warehouseKindEnum.PHYSICAL) return !warehouse.is_virtual
  if (props.kind === warehouseKindEnum.VIRTUAL) return warehouse.is_virtual
  return true
}

const selectableWarehouses = computed(() => warehouses.value.filter(w =>
  !w.archived && w.id !== props.exclude && matchesKind(w)
))

onMounted(async () => {
  warehouses.value = (await planningStore.fetchWarehousesAsync({ all: true })).data
})
</script>
<template>
  <q-select
    :model-value="modelValue"
    :label="label || i18n.t('common.warehouse')"
    option-value="id"
    option-label="name"
    :options="selectableWarehouses"
    emit-value
    map-options
    :rules="required ? [val => val != null || i18n.t('common.required')] : []"
    :clearable="allowAll"
    :display-value="allowAll && modelValue == null ? i18n.t('common.all') : undefined"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #option="scope">
      <q-item v-bind="scope.itemProps">
        <q-item-section>
          <warehouse-name-label :warehouse="scope.opt" />
        </q-item-section>
      </q-item>
    </template>
    <template #selected-item="scope">
      <warehouse-name-label v-if="scope.opt?.id != null" :warehouse="scope.opt" />
    </template>
  </q-select>
</template>
